/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import dashboard from './dashboard'
import orders from './orders'
import product from './product'
import settings from './settings'
import relations from './relations'
import finance from './finance'
import data from './data'

// Array of sections
export default [...dashboard, ...orders, ...relations, ...finance, ...product, ...data, ...settings]
